import React from "react";
import { css } from "@emotion/react";
import { Font } from "@moneyforward/mfx_biz_react_components";
import { useIsSpMode } from "@/hooks";

type Props = {
  temporaryPassword: string;
};

export const TemporaryPasswordLabel = (props: Props) => {
  const isSpMode = useIsSpMode();
  return (
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        <Font variant="m" component="p">
          仮パスワード
        </Font>
      </div>
      <div css={inputWrapper}>
        <Font>{props.temporaryPassword}</Font>
      </div>
    </div>
  );
};

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "160px",
  marginRight: "15px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  width: "100%",
  paddingTop: "8px",
  flex: 1,
});
